<ng-container *ngIf="!isPontoFlow">
    <app-bank-transactions></app-bank-transactions>
</ng-container>
<ng-container *ngIf="isPontoFlow">
    <app-ponto-bank-transactions></app-ponto-bank-transactions>
</ng-container>